import { render } from "./CptBilling.vue?vue&type=template&id=544731f4&scoped=true"
import script from "./CptBilling.vue?vue&type=script&lang=js"
export * from "./CptBilling.vue?vue&type=script&lang=js"

import "./CptBilling.vue?vue&type=style&index=0&id=544731f4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-544731f4"]])

export default __exports__